// services/salesforce.js
import apiClient from './api';

/**
 * Refreshes an expired Salesforce OAuth token for a specific org.
 * Corresponds to: POST /api/oauth2/refresh
 */
export async function refreshSalesforceToken(orgId) {
  // The server knows the user/tenant from the session. We just need to tell it WHICH org.
  const response = await apiClient.post('/oauth2/refresh', { orgId });
  return response.data;
}

/**
 * Tests the validity of a Salesforce connection for a specific org.
 * Corresponds to: POST /api/oauth2/test_connection
 */
export async function testSalesforceConnection(orgId) {
  const response = await apiClient.post('/oauth2/test_connection', { orgId });
  return response.data;
}
